export default __webpack_public_path__ + "static/submittable-logo_no-box__white-4763c6811e66d4eb0b941bf8251dc4a6.svg";